import {$host} from "./index";

export const getDevices = async () => {
    return await $host.get('/things', {params: {limit: 100}})
}

export const getDevice = async (thingId) => {
    return await $host.get(`/things/${thingId}`)
}

export const updateDevice = async (id, key, metadata, name) => {
    return await $host.put(`/things/${id}`, {id, key, metadata, name})
}

// https://iot.faradaydc.ru/reader/channels/87ddce90-2ba0-450d-8bae-b4670c0d062d/messages?name=urn:dev:ops:60689-tl101-000120:v
export const getVoltage = async (deviceId, channelId, firstTime, lastTime) => {
    return await $host.get(`/reader/channels/${channelId}/messages`,{ params: { name:`${deviceId}:v`, limit: 1000, from: `${firstTime}`, to: `${lastTime}`,}})
}

export const getCurrent = async (deviceId, channelId, firstTime, lastTime) => {
    return await $host.get(`/reader/channels/${channelId}/messages`,{ params: { name:`${deviceId}:i`, limit: 1000, from: `${firstTime}`, to: `${lastTime}`,}})
}

export const getTemperature = async (deviceId, channelId, firstTime, lastTime) => {
    return await $host.get(`/reader/channels/${channelId}/messages`,{ params: { name: `${deviceId}:te`, limit: 1000, from: `${firstTime}`, to: `${lastTime}`,}})
}

export const getHumidity = async (deviceId, channelId, firstTime, lastTime) => {
    return await $host.get(`/reader/channels/${channelId}/messages`,{ params: { name:`${deviceId}:h`, limit: 1000, from: `${firstTime}`, to: `${lastTime}`,}})
}

export const getLat = async (deviceId, channelId, firstTime, lastTime) => {
    return await $host.get(`/reader/channels/${channelId}/messages`,{ params: { name:`${deviceId}:lat`, limit: 1, from: `${firstTime}`, to: `${lastTime}`,}})
}

export const getLon = async (deviceId, channelId, firstTime, lastTime) => {
    return await $host.get(`/reader/channels/${channelId}/messages`,{ params: { name:`${deviceId}:lon`, limit: 1, from: `${firstTime}`, to: `${lastTime}`,}})
}

export const getIMEI = async (deviceId, channelId, firstTime, lastTime) => {
    return await $host.get(`/reader/channels/${channelId}/messages`,{ params: { name:`${deviceId}:imei`, limit: 1, from: `${firstTime}`, to: `${lastTime}`,}})
}

export const getICCID = async (deviceId, channelId, firstTime, lastTime) => {
    return await $host.get(`/reader/channels/${channelId}/messages`,{ params: { name:`${deviceId}:iccid`, limit: 1, from: `${firstTime}`, to: `${lastTime}`,}})
}

export const getFW = async (deviceId, channelId, firstTime, lastTime) => {
    return await $host.get(`/reader/channels/${channelId}/messages`,{ params: { name:`${deviceId}:fw`, limit: 1, from: `${firstTime}`, to: `${lastTime}`,}})
}

export const getHW = async (deviceId, channelId, firstTime, lastTime) => {
    return await $host.get(`/reader/channels/${channelId}/messages`,{ params: { name:`${deviceId}:hw`, limit: 1, from: `${firstTime}`, to: `${lastTime}`,}})
}

export const getPdo0 = async (deviceId, channelId, firstTime, lastTime) => {
    return await $host.get(`/reader/channels/${channelId}/messages`,{ params: { name:`${deviceId}:pdo0`, limit: 1, from: `${firstTime}`, to: `${lastTime}`,}})
}

export const getPdo1 = async (deviceId, channelId, firstTime, lastTime) => {
    return await $host.get(`/reader/channels/${channelId}/messages`,{ params: { name:`${deviceId}:pdo1`, limit: 1, from: `${firstTime}`, to: `${lastTime}`,}})
}

export const getCode = async (deviceId, channelId, firstTime, lastTime) => {
    return await $host.get(`/reader/channels/${channelId}/messages`,{ params: { name:`${deviceId}:code`, limit: 1000, from: `${firstTime}`, to: `${lastTime}`,}})
}

export const getRSSI = async (deviceId, channelId, firstTime, lastTime) => {
    return await $host.get(`/reader/channels/${channelId}/messages`,{ params: { name:`${deviceId}:rssi`, limit: 1000, from: `${firstTime}`, to: `${lastTime}`,}})
}